import { render, staticRenderFns } from "./status.vue?vue&type=template&id=19f9f666&"
import script from "./status.vue?vue&type=script&lang=ts&"
export * from "./status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports